import { delay } from 'q'
import { SearchServiceInterface, SearchResult, SingleResponse } from '../types'

export default class MockSearchService implements SearchServiceInterface {
	public async search(): Promise<SingleResponse<SearchResult[]>> {
		await delay(500)
		return { data: [] }
	}
}
